<template>


<div   class="calculation_node raised_item" :ref="'node'+node.id" :id="'node'+node.id" :style="offsets">
<div class="calculation_node_left_notch calculation_node_notch" :class="leftnotch_active" :id="'left_notch'+node.id" v-if="node.type!=='variable'"></div>
<div class="calculation_node_right_notch calculation_node_notch" :class="rightnotch_active" :id="'right_notch'+node.id" v-if="node.type!=='equation'"></div>
<!-- header-->
<div class="calculation_node_header" :class="bgcolor">
<div class="calculation_node_header_text" :id="'handle'+node.id">{{node.title}}</div>
<div class="calculation_node_header_icon raised_item" @click="showContent">	
<span class="material-icons-outlined md-30 text-white">expand_more</span>
</div>
</div>
<!-- header-->


<!-- body-->
<div class="calculation_node_body " :class="showclass">


	<div class="calculation_node_content ">
	<div class="calculation_node__animate animate_class_delay">

	<div class="calculation_node_content_inner ">
		<template v-if="node.type=='variable'">
			<small class="font-medium line-height-1" ><b>Soru:</b> </small><br/>
			<small class="font-medium line-height-1" >{{node.title}} </small><br/>
			<small class="font-medium line-height-1" ><b>Periyod:</b> </small><br/>
			<small class="font-medium line-height-1" >{{node.period_name}}</small><br/>
		</template>
	
	
	<template v-if="node.type!=='variable' && node.type!=='equation'">

		<!-- input 1-->
		<template v-if="input1">
			<template v-if="this.node.input1.type=='connection'">
				 <div class="flex align-items-center justify-content-start "> 
				<small class="font-medium line-height-2 text-primary w-full"
				v-tooltip.left="{ value: input1.title, disabled: false,class: 'custom-top-tooltip' }"
				>1. değişken</small>
				<Button icon="pi pi-trash" class="p-button-rounded p-button-text p-button-sm p-button-danger  py-0" @click="deleteConnection('input1')"/>
			</div>
			</template>
			<template v-else>
				<div class="flex align-items-center justify-content-start "> 
				 <InputNumber 
				 inputClass="w-full p-inputtext-sm py-1"   
				 v-model="input1val" 
				 mode="decimal" 
				 :minFractionDigits="0" 
				 :maxFractionDigits="50" 
				 :max="100000000000000000000000000000000000" 
				 @input="nodeinputValueChanged($event,'input1')"/>
				 <Button icon="pi pi-trash" class="p-button-rounded p-button-text p-button-sm p-button-danger  py-0" @click="deleteValue('input1')"/>
				</div>
			</template>			
		</template>
		<template v-else>
			<InputNumber 
			inputClass="w-full p-inputtext-sm py-1"  
			v-model="input1val" 
			mode="decimal" 
			:minFractionDigits="0" 
			:maxFractionDigits="50" 
			:max="100000000000000000000000000000000000" 
			@input="nodeinputValueChanged($event,'input1')" />
		</template>
		<!-- input 1-->


		 <div class="flex align-items-center justify-content-center my-1">            
           <Button  icon="pi pi-sort-alt"  class=" p-button-primary p-button-outlined  p-button-sm p-0 m-0 "  @click="swapInputs"/>
        </div>


		<!-- input 2-->
		<template v-if="input2">
			<template v-if="this.node.input2.type=='connection'">
				 <div class="flex align-items-center justify-content-start "> 
				<small class="font-medium line-height-2 text-primary w-full"
				v-tooltip.left="{ value: input2.title, disabled: false,class: 'custom-top-tooltip' }"
				>2. değişken</small>
				<Button icon="pi pi-trash" class="p-button-rounded p-button-text p-button-sm p-button-danger  py-0" @click="deleteConnection('input2')"/>
			</div>
			</template>
			<template v-else>
				<div class="flex align-items-center justify-content-start ">
				 <InputNumber 
				 inputClass="w-full p-inputtext-sm py-1"   
				 v-model="input2val" mode="decimal" 
				 :minFractionDigits="0" 
				 :maxFractionDigits="50" 
				 :max="100000000000000000000000000000000000" 
					 onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
				 @input="nodeinputValueChanged($event,'input2')"/>
				 <Button icon="pi pi-trash" class="p-button-rounded p-button-text p-button-sm p-button-danger  py-0" @click="deleteValue('input2')"/>
				</div>
			</template>			
		</template>
		<template v-else>
			<InputNumber 
			inputClass="w-full p-inputtext-sm py-1"  
			v-model="input2val" 
			mode="decimal" 
			:minFractionDigits="0" 
			:maxFractionDigits="50" 
			:max="100000000000000000000000000000000000" 
			@input="nodeinputValueChanged($event,'input2')" />
		</template>
		<!-- input 2-->

		


	</template>



	</div>


	<div class="node_footer flex align-items-center justify-content-end">
		<Button  icon="pi pi-times"  class=" p-button-danger p-button-outlined  p-button-sm p-0 m-0" @click="deleteNode"/>
	</div>
	</div>
	</div>



</div>
<!-- body-->
</div>


</template>

<script>
export default {

  name: 'CalculationNode',
  props:["node"],
  data () {
    return {
    	input1val:null,
    	input2val:null,
    	active:false,
    	show_content:false,  
    }
  },
  watch:{
  	node()
  	{
  		if(this.node.input1 && this.node.input1.type=="value")
  		{
  			this.input1val = this.node.input1.value
  		}

  		if(this.node.input2 && this.node.input2.type=="value")
  		{
  			this.input2val = this.node.input2.value
  		}
  	},
  },
  computed:{
  	input1()
  	{
  		
  		if(this.node.input1)
  		{
  			if(this.node.input1.type=="connection")
  			{
  				let connections = this.$store.state.calculations.connections
	  			let nodes = this.$store.state.calculations.nodes
	  			let connected = connections.find((item)=>{return item.id == this.node.input1.connection_id})
	  			if(connected)
	  			{
	  				let from = nodes.find((item)=>{return item.id == connected.from})
	  				return from
	  			}
	  			else
	  			{
	  				let node_ind = nodes.findIndex((item)=>{return item.id == this.node.id})
	  				nodes[node_ind].input1 = null
	  				this.$store.dispatch('calculations/setNodes',nodes)
	  				return null
	  			}
	  			
  			}
  			else
  			{
  				this.input1val = this.node.input1.value
  				return this.node.input1.value
  			}
  			
  		}
  		else
  		{
  			return null
  		}  		
  	},

  	input2()
  	{
  		if(this.node.input2)
  		{
  			if(this.node.input2.type=="connection")
  			{
  				let connections = this.$store.state.calculations.connections
	  			let nodes = this.$store.state.calculations.nodes
	  			let connected = connections.find((item)=>{return item.id == this.node.input2.connection_id})
	  			if(connected)
	  			{
	  				let from = nodes.find((item)=>{return item.id == connected.from})
	  				return from
	  			}
	  			else
	  			{
	  				let node_ind = nodes.findIndex((item)=>{return item.id == this.node.id})
	  				nodes[node_ind].input2 = null
	  				this.$store.dispatch('calculations/setNodes',nodes)
	  				return null
	  			}
  			}
  			else
  			{
  				this.input2val = this.node.input2.value
  				return this.node.input2.value
  			}
  			
  		}
  		else
  		{
  			return null
  		}  				
  	},
  	coordinates()
  	{
  		if(this.show_content)
  		{
  			return "left:"+this.node.top+"px;left:"+this.node.left+"px;z-index:100"
  		}
  		else
  		{
  			return "left:"+this.node.top+"px;left:"+this.node.left+"px;"
  		}
  		
  	},
  	offsets()
  	{
  		if(this.show_content)
  		{
  			return "left:"+this.node.offsetX+"px;top:"+this.node.offsetY+"px;z-index:100"
  		}
  		else
  		{
  			return "left:"+this.node.offsetX+"px;top:"+this.node.offsetY+"px"
  		}
  		
  	},
  	showclass()
  	{
  		if(this.show_content)
  		{
  			return "open"
  		}
  		else
  		{
  			return ""
  		}
  	},
  	bgcolor()
  	{
  		if(this.node.type=="variable")
  		{
  			return "calculation_node_variable"
  		}
  		if(this.node.type=="equation")
  		{
  			return "calculation_node_equation"
  		}
  		if(this.node.type!=="variable" || this.node.type!=="equation")
  		{
  			return "calculation_node_calculation"
  		}
  	},
  	rightnotch_active()
  	{
  		if(this.$store.state.calculations.fromnode && this.$store.state.calculations.fromnode.id==this.node.id)
  		{
  			return "full"
  		}
  		else
  		{
  			let connections = this.$store.state.calculations.connections
  			for (let i = 0; i <connections.length; i++) {
  				if(connections[i].from == this.node.id)
  				{
  					return "full"
  				}
  			}
  			return ""
  		}
  	},
  	leftnotch_active()
  	{
  		if(this.$store.state.calculations.tonode && this.$store.state.calculations.tonode.id==this.node.id)
  		{
  			return "full"
  		}
  		else
  		{
  			let connections = this.$store.state.calculations.connections
  			for (let i = 0; i <connections.length; i++) {
  				if(connections[i].to == this.node.id)
  				{
  					return "full"
  				}
  			}
  			return ""
  		}
  	}

  },
  mounted()
  {

    





  },
  methods:{
  	swapInputs()
  	{
  		let nodes = this.$store.state.calculations.nodes

  		let node_ind = nodes.findIndex((item)=>{return item.id == this.node.id})

  		if(nodes[node_ind].input1 || nodes[node_ind].input2)
  		{
  			let input1 = this.sanitizeArray(nodes[node_ind].input1)
  			let input2 = this.sanitizeArray(nodes[node_ind].input2)
  			nodes[node_ind].input1 = input2
  			nodes[node_ind].input2 = input1
  			this.$store.dispatch('calculations/setNodes',nodes)
  		}

  	},
  	deleteConnection(input)
  	{
  		console.log(this.node[input])
  		//return false
  		let connections = this.$store.state.calculations.connections
  		//let connections = connections.find((item)=>{return item.id == this.node[input].connection_id})
  		connections = connections.filter((item)=>{return item.id !==this.node[input].connection_id})  		
  		this.$store.dispatch('calculations/setConnections',connections)  		
  		let nodes = this.$store.state.calculations.nodes
  		let ind = nodes.findIndex((item)=>{return item.id == this.node.id})
  		nodes[ind][input] = null
  		console.log(nodes)
  		setTimeout(()=>{
  			if(input=='input1')
  			{
  				this.input1val = null
  			}
  			if(input=='input2')
  			{
  				this.input2val = null
  			}
  			this.$store.dispatch('calculations/setNodes',nodes)
  			this.$store.state.calculations.fromnode = null
  		},10) 		

  	},
  	deleteValue(input)
  	{

  		let nodes = this.$store.state.calculations.nodes
  		let ind = nodes.findIndex((item)=>{return item.id == this.node.id})
  		nodes[ind][input] = null
  		setTimeout(()=>{
  			if(input=='input1')
  			{
  				this.input1val = null
  			}
  			if(input=='input2')
  			{
  				this.input2val = null
  			}
  			this.$store.dispatch('calculations/setNodes',nodes)
  		},10) 
  	},
  	nodeinputValueChanged(e,input)
  	{
  		let nodes = this.$store.state.calculations.nodes
  		let ind = nodes.findIndex((item)=>{return item.id == this.node.id})
  		if(this.node[input])
  		{
  			console.log("input val set")
  			nodes[ind][input].value = e.value
  			this.$store.dispatch('calculations/setNodes',nodes)
  		}
  		else
  		{
  			console.log("input val not set")
  			let val_item = {value:e.value,type:"value"}
  			nodes[ind][input] = val_item
  			this.$store.dispatch('calculations/setNodes',nodes)

  		}
  		console.log(e)
  	},
  	showContent()
  	{
  		this.show_content = !this.show_content
  	},

   
   
    deleteNode()
    {
    	let nodes = this.$store.state.calculations.nodes
    	let connections = this.$store.state.calculations.connections
    	let node_ind = nodes.findIndex((item)=>{return item.id == this.node.id})

    	console.log("deleteNode")
    	console.log(this.node)


    	if(this.node.type=="variable")
    	{
    		let output_cons = connections.filter((item)=>{return item.from==this.node.id})
    		for(let output_conn of output_cons)
    		{
    			connections = connections.filter((item)=>{return item.id !== output_conn.id})
    			this.$store.dispatch('calculations/setConnections',connections)
    		}
    		
    	}
    	else if(this.node.type=="equation")
    	{
    		let input_conns = connections.filter((item)=>{return item.to==this.node.id})
    		for(let input_conn of input_conns)
    		{
    			connections = connections.filter((item)=>{return item.id !== input_conn.id})
    			this.$store.dispatch('calculations/setConnections',connections)
    		}
    		
    	}
    	else
    	{
    		let output_conns = connections.filter((item)=>{return item.from==this.node.id})
    		for(let output_conn of output_conns)
    		{
    			connections = connections.filter((item)=>{return item.id !== output_conn.id})
    		}
    		

    		let input_conns = connections.filter((item)=>{return item.to==this.node.id})

    		for(let input_conn of input_conns)
    		{
    			connections = connections.filter((item)=>{return item.id !== input_conn.id})
    		}
    		this.$store.dispatch('calculations/setConnections',connections)
    		
    	}

    	setTimeout(()=>{
    		nodes = nodes.filter((item)=>{return item.id !== nodes[node_ind].id})
    		this.$store.dispatch('calculations/setNodes',nodes)
    		this.$store.state.calculations.fromnode = null
    	},10)

    	
    },

  	
  }

}
</script>

<style lang="css" scoped>
</style>